<ng-container *ngIf="(surveyViewerService.activeSurvey$ | async).form.get(this.question.key)">
  <div data-testId="radioForm">
    <ng-container [formGroup]="$any(questionFormControl)">
      <ng-container *ngFor="let statementKey of question.statementsOrder">
        <mat-radio-group
          [color]="'primary'"
          [formControlName]="statementKey"
          aria-labelledby="radio-group-label"
          class="vertical-radio-group"
        >
          <mat-radio-button
            (change)="question.resetPreviousRadioStatementFormSelection(question.rowKeys.pop(), statementKey, this.surveyViewerService.activeSurvey$.value.form.get(this.question.key))"
            [value]="true"
            class="radio-input"
            [class.option-disabled]="isOptionDisabled(statementKey)"
            data-testId="radio"
          >
            <img
              *ngIf="surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang) && question.useImage"
              src="{{surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang)}}"
              alt="image" [style.width]="question.imageSize+'px'"
              class="image-label"
            >
            {{question.statements[statementKey].label | translateLabel: activeLang}}
          </mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="commentsFormControl.get(statementKey) && questionFormControl.get(statementKey).value">
          <mat-form-field [color]="'primary'" appearance="outline" class="w-full comment-field">
            <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                   [formControl]="$any(commentsFormControl.get(statementKey))"
                   (input)="onInput($event.target.value, statementKey)"
                   (blur)="onBlur($event.target.value.trim(), statementKey)">
            <mat-error>
              {{'Le commentaire ne peut être vide'|transloco}}.
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isValidAI[statementKey]| async as isValidAI">
            <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{isValidAI.explication}}</div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <mat-error
      *ngIf="surveyViewerService.activeSurvey$.value.form.get(question.key).errors && surveyViewerService.allFormControlsMarkedAsTouched$.value">
      {{'Vous devez faire une sélection'|transloco}}.
    </mat-error>
  </div>
</ng-container>
